import { useLocation } from '@tanstack/react-router'
import { useSession } from './use-session'

export const useCompanyIsActive = () => {
  const { pathname } = useLocation()

  const { data: session, isPending } = useSession()

  if (isPending || !session) {
    return pathname.startsWith('/companies')
  }

  const companyIsActive =
    session.user.userType === 'staff'
      ? pathname.startsWith('/companies')
      : pathname.startsWith('/companies') || pathname.startsWith('/applications')

  return companyIsActive
}
